export const MEASURECAMP_CALENDAR_URL =
  'https://raw.githubusercontent.com/BranislavMateas/measurecamp-calendar-scraper/main/measurecamp-events.ics'

export const MEASURECAMP_EVENTS_URL =
  'https://raw.githubusercontent.com/BranislavMateas/measurecamp-calendar-scraper/main/events.json'

export const MEASURECAMP_REPOSITORY_URL =
  'https://github.com/BranislavMateas/measurecamp-calendar-scraper'

export interface MeasureCampEvent {
  id: string
  city: string
  url: string
  date: string
  time: string
  venue: string
  address: string
  last_updated: string
}

interface MeasureCampEventsResponse {
  events?: MeasureCampEvent[]
}

export async function getUpcomingMeasureCampEvents(limit = 5): Promise<MeasureCampEvent[]> {
  try {
    const response = await fetch(MEASURECAMP_EVENTS_URL, {
      next: { revalidate: 21_600 },
    })

    if (!response.ok) return []

    const data = (await response.json()) as MeasureCampEventsResponse
    const today = new Date().toISOString().slice(0, 10)
    const latestReasonableYear = new Date().getUTCFullYear() + 2

    return (data.events ?? [])
      .filter((event) => {
        const year = Number(event.date.slice(0, 4))
        return event.date >= today && year <= latestReasonableYear
      })
      .sort((a, b) => a.date.localeCompare(b.date))
      .slice(0, limit)
  } catch {
    return []
  }
}
